import React, { memo } from "react"

import { Link } from "react-router-dom"
import { Ellipsis } from "@dit/core-frontend"

export const EntityLink = memo(
  ({
    entity,
    isEntityPage = false,
    link,
    visibleField = "slug",
    customVisibleField = null,
    linkProps = {},
    ...props
  }) => {
    const linkEnd = isEntityPage && entity.key ? entity.key : entity.slug

    return (
      <Link to={`${link}/${linkEnd}`} {...linkProps}>
        <Ellipsis lines={2} {...props}>
          {customVisibleField || entity[visibleField]}
        </Ellipsis>
      </Link>
    )
  },
)

EntityLink.displayName = "EntityLink"
